/* eslint-disable */
import * as React from "react";
import { ContextReport1 } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { useData1 } from "../data/useData1";
import { useChart2 } from "../transformers/useChart2";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { Table, TableProps } from "../../../components/Table";
import { ComponentContextReadyState } from "@sa/rep-core";
import { useParameter, yearToCropYearShort, useDictionaryItem, castUnit, GLOBAL_UNIT } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { first } from "lodash";
import { SERIES_AXIS, CATEGORIES_AXIS } from "../constants";

export const ComponentChart2: React.FC<{ context: ContextReport1 }> = (props) => {
  const context = props.context;
  const orderedCountriesIds = useHookSubscribe(null, context.orderedCountriesIds$);
  const olapCountriesArea = useHookSubscribe(null, context.olapCountriesArea$);
  const highlightData = useHookSubscribe(null, context.highlightData);
  const olapWorldArea = useHookSubscribe(null, context.olapWorldArea$);
  const unitsParam = useHookSubscribe(['9'], context.units$);

  const unit = Number((unitsParam || [])[0] ?? '9');
  const worldStart = castUnit(olapWorldArea?.data.rows[0]?.cells[0]?.value, GLOBAL_UNIT.AREA_MHA, unit);
  const worldEnd = castUnit(olapWorldArea?.data.rows[olapWorldArea?.data.rows.length - 1]?.cells[0]?.value, GLOBAL_UNIT.AREA_MHA, unit);

  const data = useData1(olapCountriesArea);
  const tableData = useChart2(data, orderedCountriesIds, unit);

  const getRowClass = React.useCallback(
    (params: any) => {
      let rowClass = "";
      if (
        highlightData &&
        highlightData.highlightType === "row" &&
        params.data.rawPeriod === highlightData[`${SERIES_AXIS}.name`]
      ) {
        rowClass = "row_highlight";
      }
      return rowClass;
    },
    [highlightData],
  );

  const getCellClass = React.useCallback(
    (params: any) => {
      let cellClass = "";
      if (
        highlightData &&
        highlightData.highlightType === "cell" &&
        params.data.rawPeriod === highlightData[`${SERIES_AXIS}.name`] &&
        params.colDef.headerName === highlightData[`${CATEGORIES_AXIS}.name`]
      ) {
        cellClass = "cell_highlight";
      }
      return cellClass;
    },
    [highlightData],
  );

  const table = React.useMemo(
    () => (tableData ? <Table {...tableData} getRowClass={getRowClass} getCellClass={getCellClass} /> : null),
    [tableData, getRowClass, getCellClass],
  );

  const [, unitsName] = useDictionaryItem(dictionaryService, "slides-units", unit);

  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", first(parameterValues));
  const unitDisplay = React.useMemo(() => unitsName ? `(${unitsName[9]})` : '', [unitsName]);
  const year = calendarName ? Number(calendarName) : (new Date().getFullYear() - 1);
  const title = `Area ${unitDisplay} World area harvested: ${yearToCropYearShort(year - 6)}: ${worldStart ? `${worldStart.toFixed(0)} ${unitDisplay}` : ''} - ${yearToCropYearShort(year + 10)}: ${worldEnd ? `${worldEnd.toFixed(0)} ${unitDisplay}` : ''}`;

  if (window['exportMode']) {
    window["exportReady"] = tableData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (!window["exportMode"] && (!tableData || context.readyState === ComponentContextReadyState.Loading)) {
    return <ComponentPreloader />;
  }
  return (
    <>
      <ComponentTitle>{title}</ComponentTitle>
      <ComponentSourcetitle> </ComponentSourcetitle>
      {table}
    </>
  );
};
